import moment from "moment";
import { TYPES } from "../actions";

const initialState = {
  collections: [],
  favorite: null
};

const FAVORITE_NAME = '__FAVORITES__';

const filterCollection = (data) => {
  return data.filter(collection => collection.name != FAVORITE_NAME);
}

const filterFavorite = (data) => {
  if (data.length == 0)
    return null;

  return data.filter(collection => collection.name == FAVORITE_NAME)[0];
}

export const collectionReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPES.ACTION_GET_ALL_COLLECTIONS_SUCCESS:
      return { ...state,
        collections: filterCollection(action.payload.data),
        favorite: filterFavorite(action.payload.data)
      }

    case TYPES.ACTION_ADD_NEW_COLLECTION_SUCCESS:
      return { ...state, 
        collections: [...state.collections, action.payload.data]
      }

    case TYPES.ACTION_TOGGLE_LISTING_IN_COLLECTION_SUCCESS:
      if (action.payload.data.name == FAVORITE_NAME)
        return { ...state,
          favorite: action.payload.data
        };

      return { ...state, 
        collections: state.collections.map(collection => 
          collection._id == action.payload.data._id? action.payload.data: collection)
      }

    case TYPES.ACTION_UPDATE_COLLECTION_SUCCESS:
      if (action.payload.data.status == -1) { //delete
        return { ...state, 
          collections: state.collections.filter(collection => collection._id != action.payload.data._id)
        }
      }

      return { ...state, 
        collections: state.collections.map(collection => 
          collection._id == action.payload.data._id? action.payload.data: collection)
      }

    case TYPES.ACTION_ADD_ALL_LISTING_TO_NEW_COLLECTION_SUCCESS:
      return { ...state, 
        collections: [...state.collections, action.payload.data.collection]
      }
      
    default:
      return state;
  }
};
